<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <progress v-if="!busquedaFinalizada" class="progress is-small is-primary" max="100"></progress>
        <div v-else class="box">
          <div class="title">{{datosUsuario.nombre}} {{datosUsuario.apellido}}</div>

          <div class="is-divider is-primary"></div>
          <div class="title is-5">Correo Electrónico</div>
          <div class="subtitle is-6">{{datosUsuario.email}}</div>
          <div class="title is-5">{{datosUsuario.tipoDocumento}}</div>
          <div class="subtitle is-6">{{datosUsuario.documento}}</div>
          <div class="title is-5">Sexo</div>
          <div class="subtitle is-6">{{datosUsuario.sexo}}</div>
          <div class="title is-5">Dirección</div>
          <div
            class="subtitle is-6"
          >{{datosUsuario.direccion}} - {{datosUsuario.localidad}} - {{datosUsuario.provincia}}</div>
        <template v-if="datosUsuario.fechaDeNacimiento">
          <div class="title is-5">Nacimiento</div>
          <div
            class="subtitle is-6"
          >{{ new Date(datosUsuario.fechaDeNacimiento).toLocaleDateString() }}</div>
        </template>
          <div class="title is-5">Teléfono</div>
          <div class="subtitle is-6">{{datosUsuario.telefono}}</div>
          <router-link
            :to="{name: 'change-password'}"
            class="button is-secundary"
          >Cambiar mi contraseña</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  name: 'Perfil',
  data () {
    return {
      titulo: 'Mi Perfil',
      subtitulo: 'La información que tenemos de vos',
      datosUsuario: {},
      busquedaFinalizada: false
    }
  },
  components: {
    TituloPrincipal
  },
  created () {
    var id = this.$VueJwtDecode.decode(localStorage.getItem('jwt')).id
    var componenteVue = this

    function postGetUsuario (error, data) {
      if (error) {
        componenteVue.mensajeErrorAxios(error, componenteVue)
      } else {
        componenteVue.datosUsuario = data
        componenteVue.busquedaFinalizada = true
      }
    }

    this.$apiService.getUsuarioById(id, postGetUsuario)
  }
}
</script>
